export const useFilterVeeValidateRules = (rules: string | string[]) => {
  if (!rules) return ''

  const existingRules = [
    'required',
    'email',
    'numeric',
    'integer',
    'max',
    'min',
    'url',
    'phone',
    'nullable',
    // 'mimes', // statamic sends a empty object as rule
    // 'image', // statamic sends a empty object as rule
    'max_files',
    'min_files',
  ]

  // If the rules are a string, split them into an array
  if (typeof rules === 'string') {
    rules = rules.split('|')
  }

  // Filter every element which is not a string
  rules = rules.filter(rule => typeof rule === 'string')

  const filteredRules = rules.filter((rule) => {
    return existingRules.some((existingRule) => {
      return (
        rule.startsWith(existingRule)
        && (rule.length === existingRule.length
          || rule[existingRule.length] === ':')
      )
    })
  })

  return filteredRules.join('|')
}
